export default {
    setCurrentStep(state, step) {
        state.activeStep = step
    },
    setIsStepsClickable(state, isStepClickable) {
        state.isStepsClickable[isStepClickable.index] = isStepClickable.value
    },
    setPrefillAnswers(state, answers) {
        state.prefillAnswers = answers
    }
}
